import type {ComponentProps, FC} from 'react';
import type {VariantProps} from 'class-variance-authority';
import {cva} from 'class-variance-authority';

import {cn} from '../../shared/tailwind';
import {Heading, type HeadingProps} from '../typography/heading';
import type {ParagraphProps} from '../typography/paragraph';
import {Paragraph} from '../typography/paragraph';

const alert = cva('border-2 p-4 rounded bg-primary', {
	variants: {
		severity: {
			info: 'border-primary/40 bg-primary/20 ',
			danger: 'border-red-500/40 bg-red-500/20',
			warning: 'border-amber-500/40 bg-orange-500/20 ',
		},
	},
	defaultVariants: {
		severity: 'info',
	},
});

export type AlertProps = VariantProps<typeof alert> & ComponentProps<'div'>;

/**
 * Button used for interaction
 */
export const Alert: FC<AlertProps> = ({children, severity = 'info', className, ...rest}) => {
	return (
		<div className={cn(alert({severity}), className)} {...rest}>
			{children}
		</div>
	);
};

Alert.displayName = 'Alert';

export const AlertHeading: FC<HeadingProps> = ({children, className, level, size, ...rest}) => {
	return (
		<Heading
			level={level ?? 2}
			size={size ?? 'h5'}
			className={cn('font-sans font-bold', className)}
			{...rest}
		>
			{children}
		</Heading>
	);
};

export const AlertBody: FC<ParagraphProps> = ({children, size, ...rest}) => {
	return (
		<Paragraph size={size ?? 'small'} {...rest}>
			{children}
		</Paragraph>
	);
};
